import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {WriteLeaveForm} from "@/pages/Leave/WriteLeave";
import {SearchBO} from "@/service/common.s";
import {LeavePO} from "@/model/content";
import {ReviewStatusVO} from "@/service/instance.s";
import {ConfirmLeaveForm} from "@/widget/ProcessApproval/ConfirmLeave";

export enum LeaveEnum {
    GetLeavePage = "/leave/getLeavePage",
    GetLeave = "/leave/getLeave",
    CreateLeave = "/leave/createLeave",
    SearchLeave = "/leave/searchLeave",
    UpdateLeave = "/leave/updateLeave",
    ConfirmLeave = "/leave/confirmLeave",
}

export interface LeavePageBO {
    keyword?: string;
}

export interface SearchLeaveVO extends LeavePO {
    id: number
}

export interface LeavePageVO extends LeavePO, ReviewStatusVO {
    avatar: string;
}

export interface LeaveVO extends LeavePO {
}

export const useQueryLeavePage = () => useMutation<BaseVO<PaginationVO<LeavePageVO>>, null, LeavePageBO>({
    mutationFn: (data: LeavePageBO) => http.post<BaseVO<PaginationVO<LeavePageVO>>>({
        url: LeaveEnum.GetLeavePage,
        data: data,
    }),
})

export const useQueryLeave = (params: GetByIdBO, enabled?: boolean) => useQuery<BaseVO<LeavePO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<LeaveVO>>({
        url: LeaveEnum.GetLeave,
        params: params
    }),
    enabled: enabled,
})

export const useCreateLeave = () => useMutation({
    mutationFn: (data: WriteLeaveForm) => http.put<BaseVO<null>>({url: LeaveEnum.CreateLeave, data}),
})

export const useConfirmLeave = () => useMutation({
    mutationFn: (data: ConfirmLeaveForm) => http.put<BaseVO<null>>({url: LeaveEnum.ConfirmLeave, data}),
})

export const useUpdateLeave = () => useMutation({
    mutationFn: (data: WriteLeaveForm) => http.post<BaseVO<null>>({url: LeaveEnum.UpdateLeave, data}),
})

export const useSearchLeave = () => useMutation({
    mutationFn: (data: SearchBO) => http.post<BaseVO<SearchLeaveVO[]>>({url: LeaveEnum.SearchLeave, data})
})


